import * as React from 'react'
import type { SVGProps } from 'react'
function SvgFreieFlachenFlachennutzungsintensitat221982627117(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 233.1 199.8"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M232.2,180.2l-9.3-25.4c-1.2-3.3-3.6-6-6.6-7.7c2.5-2.5,4-6,4-9.8V14c0-7.7-6.3-14-14-14H26.7c-7.7,0-14,6.3-14,14v123.3 c0,3.8,1.5,7.3,4,9.8c-3,1.7-5.4,4.4-6.6,7.7l-9.3,25.4c-1.6,4.5-1,9.4,1.8,13.3c2.7,3.9,7.2,6.2,11.9,6.2l203.9,0 c4.7,0,9.2-2.3,11.9-6.2C233.2,189.6,233.8,184.7,232.2,180.2z M225.4,190c-1.6,2.3-4.1,3.6-6.9,3.6H14.6c-2.8,0-5.3-1.3-6.9-3.6 c-1.6-2.3-2-5.1-1-7.8l9.3-25.4c1.2-3.3,4.4-5.6,8-5.6h2.9h179.6h2.9c3.5,0,6.7,2.2,8,5.6l9.3,25.4 C227.4,184.9,227,187.7,225.4,190z M18.8,14c0-4.4,3.5-7.9,7.9-7.9h179.6c4.4,0,7.9,3.5,7.9,7.9v123.3c0,4.4-3.5,7.9-7.9,7.9H26.7 c-4.4,0-7.9-3.5-7.9-7.9V14z" />
        <path d="M45.7,71.7l-1,1l1.3-0.9c0.5,0.2,1,0.3,1.5,0.3H53v39.2c0,2.7,2.2,5,5,5h54.2l0.2,0l0,0c2.6-0.1,4.8-2.3,4.8-5v-8.9 c0-1.7-1.4-3-3-3c-1.7,0-3.1,1.4-3.1,3v7.8h-52V69.1c0-1.7-1.4-3.1-3-3.1h-2.2l31.2-24.5L103.6,56c1.3,1,3.2,0.8,4.3-0.5 c1-1.3,0.8-3.2-0.5-4.3L88.1,36.1c-1.8-1.4-4.2-1.4-6,0l-37,29c-1.3,1-1.9,2.8-1.3,4.3C44.1,70.4,44.8,71.2,45.7,71.7z" />
        <path d="M146.7,102.4c7.3,0,14.1-2.5,19.7-7l17.9,17.9c0.6,0.6,1.3,0.9,2.2,0.9h0c0.8,0,1.6-0.3,2.2-0.9c1.2-1.2,1.2-3.1,0-4.3 l-17.9-17.9c10-12.2,9.3-30.2-2.1-41.6c-5.8-5.8-13.6-9.1-21.9-9.1c-8.3,0-16.1,3.2-21.9,9.1c-5.8,5.8-9.1,13.6-9.1,21.9 c0,8.3,3.2,16.1,9.1,21.9C130.7,99.2,138.4,102.4,146.7,102.4z M164.3,89c-4.7,4.7-10.9,7.3-17.6,7.3c-6.7,0-12.9-2.6-17.6-7.3 c-9.7-9.7-9.7-25.5,0-35.2c4.7-4.7,10.9-7.3,17.6-7.3c6.7,0,12.9,2.6,17.6,7.3c4.7,4.7,7.3,10.9,7.3,17.6 C171.6,78.1,169,84.4,164.3,89z" />
      </g>
    </svg>
  )
}
export default SvgFreieFlachenFlachennutzungsintensitat221982627117
